import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar";
import { useHeight } from "../../helpers/useHeight";
import { Footer } from "../../components/Layout/Footer";
import Style from "../../components/Layout/Applications/style";

export default function OnlyDesktop() {
  const { t } = useTranslation();
  const { height } = useHeight();

  return (
    <div style={{ height, display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Style className="only-desktop">
        <div className="apps-cont only-desktop" style={{ height }}>
          <div className="main-cont only-desktop">
            <img src="/assets/images/applications/mmt-logo.svg" alt="mmt-logo" />
            <p>{t('This application is currently optimised for use on a computer')}</p>
          </div>
          <Footer />
        </div>
      </Style>
    </div>
  )
}
